<div class="tw-flex tw-flex-col tw-gap-1">
  @if (label) {
    <span class="tw-text-[13px] tw-font-bold tw-text-dt-text-tertiary">{{ label | i18n }}</span>
  }
  <div
    class="tw-flex tw-w-full tw-h-12 tw-items-center tw-rounded-2xl tw-bg-dt-surface-card tw-p-1 tw-shadow-neuomorphic-raised-strong"
  >
    @for (dir of directions; track dir) {
      <button
        type="button"
        (click)="onDirectionChange(dir)"
        class="tw-flex tw-h-full tw-flex-1 tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-cursor-pointer tw-transition-all tw-duration-200"
        [ngClass]="
          direction() === dir
            ? 'tw-bg-dt-surface-card tw-shadow-neuomorphic-inset'
            : 'tw-bg-transparent'
        "
      >
        <span
          class="tw-font-medium tw-text-[16px] tw-tracking-[0.005em]"
          [ngClass]="
            direction() !== dir
              ? 'tw-text-dt-text-secondary'
              : dir === TransactionDirection.In
                ? 'tw-text-dt-text-in-primary'
                : 'tw-text-dt-text-out-primary'
          "
        >
          {{ dir | titlecase }}
        </span>
      </button>
    }
  </div>
</div>
